<template>
  <div class="footer-locale">
    <div class="footer-locale__inner" v-data-test-id="'locale-switch'" @click="toggleLocaleOverlay">
      <span
        class="footer-locale__flag"
        :style="`background-image: url(${getFlagSrc(selectedCountry.code)})`"
      ></span>
      <span class="footer-locale__country" v-data-test-id="'country'">{{
        selectedCountry.label
      }}</span>
    </div>
    <OverlayFooterLocale
      :isOverlayVisible="isOverlayVisible"
      :selectedCountry="selectedCountry"
      :selectedLanguage="language"
      @close-overlay="toggleLocaleOverlay"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import OverlayFooterLocale from '@/components/Footer/OverlayFooterLocale.vue'

export default {
  name: 'FooterLocale',
  components: { OverlayFooterLocale },
  data() {
    return {
      selectedCountry: {},
      isOverlayVisible: false,
    }
  },

  computed: {
    ...mapGetters({
      locale: 'page/locale',
      country: 'page/country',
      language: 'page/language',
    }),
  },

  watch: {
    language: {
      immediate: true,
      async handler(language) {
        if (!language) return
        const countryNames = await this.getCountryNames(language)
        this.selectedCountry = { label: countryNames[this.country], code: this.country }
      },
    },
  },

  methods: {
    toggleLocaleOverlay() {
      this.isOverlayVisible = !this.isOverlayVisible
      this.$emit('overlay-state-change', this.isOverlayVisible)
    },

    async getCountryNames(language) {
      const { default: countryNames } = await import(
        /* webpackChunkName: "[request]" */ `country-names/${language}`
      )

      return countryNames
    },

    getFlagSrc(countryCode) {
      return countryCode ? require(`@/assets/images/flags/${countryCode}.svg`) : ''
    },
  },
}
</script>

<style lang="scss" scoped>
.footer-locale {
  &__inner {
    display: inline-block;
    cursor: pointer;
  }

  &__flag {
    display: inline-block;
    position: relative;
    top: 3px;
    right: 4px;
    width: 18px;
    height: 18px;
  }
}
</style>
